var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg117(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.361,
    height: 61.357,
    viewBox: "0 0 61.361 61.357",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_019-sunglasses",
    "data-name": "019-sunglasses",
    transform: "translate(31.779 0) rotate(47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_680",
    "data-name": "Path 680",
    d: "M1.2.187.186,1.2a.637.637,0,0,0,.9.9L2.1,1.087a.637.637,0,0,0-.9-.9Z",
    transform: "translate(2.814 31.069)",
    fill: "#f24462"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_681",
    "data-name": "Path 681",
    d: "M2.463,14.383A8.425,8.425,0,1,0,14.377,2.468,8.425,8.425,0,0,0,2.463,14.383Zm.9-11.014A7.151,7.151,0,0,1,13.476,13.482,7.151,7.151,0,0,1,3.364,3.368Z",
    transform: "translate(6.07 24.1)",
    fill: "#f24462"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_682",
    "data-name": "Path 682",
    d: "M42.819,15.1a.638.638,0,0,0-.712.551A9.606,9.606,0,1,1,25.743,7.684l.02-.021,6.11-6.111a1.008,1.008,0,0,1,1.413,0L39.4,7.663l.02.021a9.557,9.557,0,0,1,2.61,5,.637.637,0,0,0,1.252-.231,10.824,10.824,0,0,0-2.932-5.637l-.026-.027-.808-.809.858-.858a1.66,1.66,0,0,0,0-2.345l-.585-.585a1.673,1.673,0,0,0-2.346,0l-.857.858L34.186.652a2.305,2.305,0,0,0-3.214,0L24.839,6.786l-.026.027A10.805,10.805,0,0,0,21.7,14.555a11.033,11.033,0,0,0,.142,1.648,8.339,8.339,0,0,0-5.63,5.632,10.854,10.854,0,0,0-6.47.923.637.637,0,0,0,.55,1.148,9.586,9.586,0,0,1,6.215-.719l.04.011.014,0A9.608,9.608,0,1,1,7.7,39.408l-.021-.019-6.11-6.111a1,1,0,0,1,0-1.413l6.11-6.111c.751-.679-.144-1.657-.878-.923L.664,30.965a2.275,2.275,0,0,0,0,3.214l2.394,2.394-.858.858a1.661,1.661,0,0,0,0,2.345l.585.585a1.673,1.673,0,0,0,2.346,0l.857-.858.808.808.027.026a10.8,10.8,0,0,0,7.617,3.114h.124a10.88,10.88,0,0,0,5.554-20.162,4.219,4.219,0,0,1,3.175-3.179,10.968,10.968,0,0,0,1.717,2.139,10.879,10.879,0,0,0,18.36-6.439.637.637,0,0,0-.552-.712ZM38.337,3.089a.385.385,0,0,1,.545,0l.585.585a.385.385,0,0,1,0,.545l-.858.858-1.13-1.13ZM4.231,39.461a.385.385,0,0,1-.545,0L3.1,38.876a.386.386,0,0,1,0-.545l.858-.858,1.13,1.13ZM18.963,22.674a10.877,10.877,0,0,0-1.5-.558,7.062,7.062,0,0,1,4.663-4.666,10.746,10.746,0,0,0,.556,1.506,5.523,5.523,0,0,0-3.715,3.719Z",
    transform: "translate(0)",
    fill: "#f24462"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_683",
    "data-name": "Path 683",
    d: "M1.087,2.1,2.1,1.087a.637.637,0,1,0-.9-.9L.187,1.2a.637.637,0,0,0,.9.9Z",
    transform: "translate(31.076 2.802)",
    fill: "#f24462"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_684",
    "data-name": "Path 684",
    d: "M2.463,14.383A8.424,8.424,0,0,0,14.377,2.468,8.424,8.424,0,0,0,2.463,14.383ZM8.42,1.273a7.152,7.152,0,0,1,5.056,12.209A7.151,7.151,0,0,1,3.364,3.368,7.1,7.1,0,0,1,8.42,1.273Z",
    transform: "translate(24.112 6.055)",
    fill: "#f24462"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_685",
    "data-name": "Path 685",
    d: "M.637,6.468a.637.637,0,0,0,.637-.637V.617A.637.637,0,0,0,0,.617V5.831A.637.637,0,0,0,.637,6.468Z",
    transform: "translate(36.648 11.336)",
    fill: "#f24462"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_686",
    "data-name": "Path 686",
    d: "M.637,10.588a.637.637,0,0,0,.637-.637V.617A.637.637,0,0,0,0,.617V9.951A.637.637,0,0,0,.637,10.588Z",
    transform: "translate(34.041 9.456)",
    fill: "#f24462"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_687",
    "data-name": "Path 687",
    d: "M.637,6.468a.637.637,0,0,0,.637-.637V.617A.637.637,0,0,0,0,.617V5.831A.637.637,0,0,0,.637,6.468Z",
    transform: "translate(18.556 29.43)",
    fill: "#f24462"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_688",
    "data-name": "Path 688",
    d: "M.637,10.588a.637.637,0,0,0,.637-.637V.617A.637.637,0,0,0,0,.617V9.951A.637.637,0,0,0,.637,10.588Z",
    transform: "translate(15.95 27.551)",
    fill: "#f24462"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg117);
export default __webpack_public_path__ + "static/media/117.2b033ba6.svg";
export { ForwardRef as ReactComponent };